import React from 'react';
import { IonIcon } from '@ionic/react';
import { alertCircleOutline } from 'ionicons/icons';
import styled from 'styled-components';

interface ImageErrorBoundaryProps {
  children: React.ReactNode;
}

interface ImageErrorBoundaryState {
  hasError: boolean;
}

const ErrorCard = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 16px;
  background: #f2f2f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: var(--mdc-theme-error);

  @media (min-width: 768px) {
    border-radius: 12px;
  }
`;

const ErrorText = styled.div`
  font-size: 11px;
  text-align: center;
  margin-top: 8px;
  color: #8e8e93;
`;

class ImageErrorBoundary extends React.Component<
  ImageErrorBoundaryProps,
  ImageErrorBoundaryState
> {
  constructor(props: ImageErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): ImageErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ImageStatusCard error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorCard>
          <IonIcon
            icon={alertCircleOutline}
            style={{ fontSize: '48px', color: 'var(--mdc-theme-error)' }}
          />
          <ErrorText>Failed to load image</ErrorText>
        </ErrorCard>
      );
    }

    return this.props.children;
  }
}

export default ImageErrorBoundary;
